<template>
    <div>
        <v-col cols="12" md="4">
            <v-btn class="btn-save" @click="showPaymentMethodDialog = true">Configuración de formas de pago</v-btn>
        </v-col>
        <v-dialog v-model="showPaymentMethodDialog" max-width="90%">
            <v-card style="height: 60%">
                <v-card-title>
                    <h3>Gestion de formas de pago</h3>
                </v-card-title>
                <v-card-text>
                    <ValidationObserver ref="observer" tag="form" v-slot="{ handleSubmit }">
                        <v-card class="pa-4">
                            <div class="card-title">
                                <b>
                                    Nueva forma de pago
                                </b>
                            </div>
                            <v-form @submit.prevent="handleSubmit(addPaymentMethod)">
                                <v-row class="mt-2">
                                    <v-col cols="12" md="3">
                                        <ValidationProvider name="Valor" rules="required" v-slot="{ errors }">
                                            <v-select outlined dense :error-messages="errors"
                                                v-model="paymentMethodName" :items="paymentsMethod" item-text="Valores"
                                                item-value="Codigo" label="Seleccione la forma de pago MH"
                                                :disabled="isEditMode"
                                                attach></v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                                            <v-text-field v-model="paymentMethodValue" dense outlined chips
                                                label="Escribe el nuevo nombre de la forma de pago del negocio"
                                                :error-messages="errors"></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <ValidationProvider name="Orden" rules="required" v-slot="{ errors }">
                                            <v-text-field v-model.number="paymentMethodOrder" dense outlined
                                                type="number" min="0" label="Orden"
                                                :error-messages="errors"></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="3" class="d-flex justify-end">
                                        <v-btn v-if="isEditMode" class="btn-warning mr-2" @click="cancelEdit">
                                            Cancelar
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                        <v-btn class="btn-save" type="submit">
                                            {{ isEditMode ? 'Modificar' : 'Agregar' }} forma de pago
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card>
                    </ValidationObserver>

                    <GeneralFilter :search="searchPaymentMethod" @emptyFilter="fetchPaymentsMethod"
                        :hideLimitLabel="true" :filterEndpoint="fetchPaymentsMethod">
                        <DxDataGrid class="isScrolledByGeneralFilter grid-max-width" :show-borders="true"
                            :data-source="paymentMethodTable" key-expr="ID" style="height: 250px;"
                            @row-updating="preparePaymentMethodOrderUpdate"
                            @row-updated="savePaymentMethodOrderFromGrid">
                            <DxEditing :allow-updating="true" :select-text-on-edit-start="true"
                                start-edit-action="click" mode="cell" />
                            <DxColumn data-field="OrderType" caption="Orden" :width="80"
                                data-type="number" :allow-editing="true" />
                            <DxColumn data-field="Codigo" caption="Codigo" :width="80" :allow-editing="false" />
                            <DxColumn data-field="Codigo_Alt" caption="Codigo_Alt" :width="120" :allow-editing="false" />
                            <DxColumn data-field="Valores" caption="Valores" :allow-editing="false" />
                            <DxColumn cell-template="template-estado" caption="Estado" :width="120" :allow-editing="false" />
                            <template #template-estado="{ data }">
                                <div style="display: flex; justify-content: center;">
                                    <v-chip 
                                        :color="data.data.isDisabled === 0 ? 'success' : 'grey'"
                                        small
                                        dark>
                                        {{ data.data.isDisabled === 0 ? 'Habilitado' : 'Deshabilitado' }}
                                    </v-chip>
                                </div>
                            </template>
                            <DxColumn cell-template="template-buttons" caption="Acciones" :width="150" :allow-editing="false" />
                            <template #template-buttons="{ data }">
                                <div style="display: flex; gap: 8px; justify-content: center;">
                                    <v-icon 
                                        :color="data.data.isDisabled === 0 ? 'warning' : 'success'" 
                                        @click="toggleEnabled(data.data)"
                                        style="cursor: pointer;"
                                        :title="data.data.isDisabled === 0 ? 'Deshabilitar' : 'Habilitar'">
                                        {{ data.data.isDisabled === 0 ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}
                                    </v-icon>
                                    <v-icon 
                                        color="primary" 
                                        @click="editPaymentMethod(data.data)"
                                        style="cursor: pointer;"
                                        title="Editar">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon 
                                        color="error" 
                                        @click="deletePaymentMethodConfirm(data.data)"
                                        style="cursor: pointer;"
                                        title="Eliminar">
                                        mdi-delete
                                    </v-icon>
                                </div>
                            </template>
                        </DxDataGrid>
                    </GeneralFilter>

                    <div class="d-flex justify-end w-full mt-4">
                        <v-btn class="secondary" @click="showPaymentMethodDialog = false">Cerrar</v-btn>
                    </div>
                </v-card-text>
            </v-card>
            <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert"/>
            <block v-if="loading" />
        </v-dialog>
    </div>
</template>
<script>
import Alerts from '@/components/Alerts';
import GeneralFilter from "@/components/GeneralFilter";
import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid';

export default {
    name: "ManageFormaPago",
    components: {
        Alerts,
        GeneralFilter,
        DxDataGrid,
        DxColumn,
        DxEditing,
    },
    props: ['win'],
    data() {
        return {
            loading: false,
            showPaymentMethodDialog: false,
            business: null,
            paymentsMethod: null,
            paymentMethodName: null,
            paymentMethodValue: '',
            paymentMethodOrder: 0,
            searchPaymentMethod: {
                filter: null,
                showDisabled: true,
            },
            paymentMethodTable: [],
            paymentsMethodToDelete: null,
            isEditMode: false,
            editingPaymentMethod: null,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
        }
    },
    mounted() {
        this.business = this.win.meta.business;
        this.fetchPaymentMethod();
        this.fetchPaymentsMethod();
    },
    methods: {
        async fetchPaymentMethod() {
            if (this.paymentsMethod !== null) return;
            this.paymentsMethod = await this.$API.paymentMethod.fetchPaymentMethod();
        },
        async fetchPaymentsMethod() {
            this.loading = true;
            this.paymentMethodTable = await this.$API.paymentMethod.fetchPaymentsMethod(this.searchPaymentMethod);
            this.loading = false;
        },
        async addPaymentMethod() {
            this.loading = true;
            
            if (this.isEditMode) {
                // Modo edición - actualizar
                this.$API.paymentMethod.updatePaymentMethod(this.editingPaymentMethod.ID, {
                    formaPago: {
                        id_forma_pago: this.editingPaymentMethod.ID,
                        Codigo: this.paymentMethodName,
                        Codigo_Alt: this.editingPaymentMethod.Codigo_Alt,
                        Valores: this.paymentMethodValue,
                        OrderType: this.normalizeOrderType(this.paymentMethodOrder),
                    }
                })
                    .then(async (result) => {
                        if (result?.success) {
                            await this.fetchPaymentsMethod();
                            this.showAlert("success", "Éxito", result?.message || "Se ha actualizado la forma de pago.");
                            await this.refreshPaymentCatalog();
                            this.cancelEdit();
                        } else {
                            this.showAlert("warning", "Advertencia", result?.message || "Ocurrió un problema actualizando la forma de pago.");
                        }
                    })
                    .catch((error) => {
                        console.error('Error al actualizar:', error);
                        this.showAlert("warning", "Advertencia", "Ocurrió un problema actualizando la forma de pago.");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                // Modo creación - agregar
                this.$API.paymentMethod.addPaymentMethod({
                    formaPago: {
                        Codigo: this.paymentMethodName,
                        Valores: this.paymentMethodValue,
                        OrderType: this.normalizeOrderType(this.paymentMethodOrder),
                    }
                })
                    .then(async () => {
                        await this.fetchPaymentsMethod();
                        await this.refreshPaymentCatalog();
                        this.showAlert("success", "Éxito", "Se ha registrado la forma de pago.");
                    })
                    .catch(() => {
                        this.showAlert("warning", "Advertencia", "Ocurrió un problema registrando la forma de pago.");
                    })
                    .finally(() => {
                        this.paymentMethodName = null;
                        this.paymentMethodValue = '';
                        this.paymentMethodOrder = 0;
                        this.loading = false;
                    });
            }
        },
        editPaymentMethod(data) {
            this.isEditMode = true;
            this.editingPaymentMethod = data;
            this.paymentMethodName = data.Codigo;
            this.paymentMethodValue = data.Valores;
            this.paymentMethodOrder = this.normalizeOrderType(data.OrderType);
            
            // Scroll al formulario
            this.$nextTick(() => {
                const formElement = this.$el.querySelector('.card-title');
                if (formElement) {
                    formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },
        cancelEdit() {
            this.isEditMode = false;
            this.editingPaymentMethod = null;
            this.paymentMethodName = null;
            this.paymentMethodValue = '';
            this.paymentMethodOrder = 0;
            this.$refs.observer?.reset();
        },
        async toggleEnabled(data) {
            this.loading = true;
            try {
                const result = await this.$API.paymentMethod.toggleEnabledPaymentMethod(data.ID);
                
                if (result?.success) {
                    await this.fetchPaymentsMethod();
                    await this.refreshPaymentCatalog();
                    const estado = result.isDisabled === 0 ? 'habilitada' : 'deshabilitada';
                    this.showAlert("success", "Éxito", `Forma de pago ${estado} correctamente.`);
                } else {
                    this.showAlert("warning", "Advertencia", result?.message || "Ocurrió un problema cambiando el estado.");
                }
            } catch (error) {
                console.error('Error al cambiar estado:', error);
                this.showAlert("warning", "Advertencia", "Ocurrió un problema cambiando el estado de la forma de pago.");
            } finally {
                this.loading = false;
            }
        },
        preparePaymentMethodOrderUpdate(data) {
            if (!Object.prototype.hasOwnProperty.call(data.newData, "OrderType")) return;

            data.newData.OrderType = this.normalizeOrderType(data.newData.OrderType);
        },
        savePaymentMethodOrderFromGrid(data) {
            return this.savePaymentMethodOrder(data.data, this.normalizeOrderType(data.data.OrderType));
        },
        async savePaymentMethodOrder(paymentMethod, OrderType) {
            this.loading = true;
            try {
                const result = await this.$API.paymentMethod.updatePaymentMethod(paymentMethod.ID, {
                    formaPago: {
                        id_forma_pago: paymentMethod.ID,
                        Codigo: paymentMethod.Codigo,
                        Codigo_Alt: paymentMethod.Codigo_Alt,
                        Valores: paymentMethod.Valores,
                        OrderType,
                    }
                });

                if (result?.success) {
                    await this.fetchPaymentsMethod();
                    this.showAlert("success", "Éxito", "Se ha actualizado el orden de la forma de pago.");
                    await this.refreshPaymentCatalog();
                } else {
                    this.showAlert("warning", "Advertencia", result?.message || "Ocurrió un problema actualizando el orden.");
                    await this.fetchPaymentsMethod();
                }
            } catch (error) {
                console.error("Error al actualizar orden:", error);
                this.showAlert("warning", "Advertencia", "Ocurrió un problema actualizando el orden.");
                await this.fetchPaymentsMethod();
            } finally {
                this.loading = false;
            }
        },
        deletePaymentMethodConfirm(data) {
            this.paymentsMethodToDelete = data
            this.showAlert(
                "question",
                "Eliminar",
                "¿Está seguro de eliminar la forma de pago?",
                "deletePaymentMethod"
            );
        },
        closeAlert() {
            this.alert.show = false;

            if (this.alert.options == "deletePaymentMethod") {
                this.paymentsMethodToDelete = null;
            }
        },
        acceptAlert() {
            this.alert.show = false;

            if (this.alert.options == "deletePaymentMethod") {
                this.loading = true;
                this.$API.paymentMethod.deletePaymentMethod(this.paymentsMethodToDelete.ID)
                    .then(async (result) => {
                        if ( result?.success) {
                            await this.fetchPaymentsMethod();
                            await this.refreshPaymentCatalog();
                        }
                        
                        this.paymentsMethodToDelete = null;
                        const typeAlert = result?.success ? 'success': 'danger';
                        this.showAlert(typeAlert, "Informacion", result?.message);
                    })
                    .catch(() => {
                        this.paymentsMethodToDelete = null;
                        this.showAlert("warning", "Advertencia", "Ocurrio un problema eliminando la forma de pago, por favor intente de nuevo.");
                    }).finally(()=> {
                        this.loading = false;
                    })
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        normalizeOrderType(value) {
            const parsedValue = Number(value);
            return Number.isFinite(parsedValue) ? parsedValue : 0;
        },
        async refreshPaymentCatalog() {
            const currentCatalog = this.$store.state.catalogMH;
            try {
                this.$store.commit("setCatalogMH", {});
                await this.$store.dispatch("getCatalogMH");
            } catch (error) {
                this.$store.commit("setCatalogMH", currentCatalog);
                console.error("Error al actualizar el catálogo de formas de pago:", error);
            }
        },
    }
};
</script>
<style scoped>
.btn-warning {
    background-color: #ff9800 !important;
    color: white !important;
}
</style>
